/**
 * WAYFARE colour system
 * ──────────────────────
 * Warm Mediterranean base (sand/cream) is the canvas — kept everywhere.
 * Two accent roles add hierarchy and energy:
 *
 *   🔶 TERRACOTTA = ACTION / energy
 *      Primary CTAs (Continue, Create, Save, Confirm), "now / today",
 *      active-trip badge, in-progress highlights. The "do it" colour.
 *
 *   🔷 BLUE = STRUCTURE / info / calm
 *      Headers, tab bars, active/selected states, secondary buttons, links,
 *      informational badges, the back button. The Mediterranean "sea".
 *
 *   🟤 BROWN/SAND = warmth
 *      Body text, labels, soft borders, page backgrounds. Stays.
 *
 * Category colours (food red, cultural purple, monuments, etc.) are functional
 * and are NOT part of this system — leave them.
 *
 * Usage: prefer these values when editing. Hex is used directly inline across the
 * app (no CSS-variable theme), so this file is the single source of truth — match
 * these exact values when you touch a colour.
 */

export const theme = {
  // ── Accent: action (terracotta) ──
  terracotta:      '#C4714A',
  terracottaDark:  '#A85B38',
  terracottaLight: '#D4895F',
  terracottaPale:  '#F2DDD2',

  // ── Accent: structure (blue) ──
  blueOcean:       '#1A3340',
  blueDeep:        '#2D5A6E',
  blue:            '#5B8FA8',
  blueLight:       '#8BAFC0',
  bluePale:        '#C8DCE5',

  // ── Warm base (kept) ──
  sand:            '#B8A082',
  sandStrong:      '#D4A574',
  brown:           '#8B7355',
  brownDark:       '#5C4A32',
  cream:           '#f5f1eb',
  creamDeep:       '#ede4d3',
  card:            '#ffffff',
};

export default theme;
